import '@valibot/i18n/uk'
import * as v from 'valibot'

v.setGlobalConfig({ lang: 'uk' })

export const ssr = false
